import { useDecisionMakerProfilePageData } from 'src/app/pages/decisionMakerProfile/pageContext';

type Result = ModelHookResult<{
	showEndorsements: boolean;
}>;

export function useEndorsementsSection(): Result {
	const {
		data: { enrichedData },
	} = useDecisionMakerProfilePageData();

	if (!enrichedData)
		return {
			data: { showEndorsements: false },
		};

	const { endorsements, endorsementsOverview, voterGuidePicks } = enrichedData;

	const hasAdvocacySupport = endorsementsOverview && endorsementsOverview.endorsers.length > 0;

	const hasEndorsementQuotes = endorsements?.some((e) => !!e.rationale);

	const hasEndorsements = endorsements && endorsements.length > 0;

	const hasVoterGuidePicks = voterGuidePicks && voterGuidePicks.length > 0;
	const hasRecommenders = hasEndorsements || hasVoterGuidePicks;

	const showEndorsements = !!hasAdvocacySupport || !!hasRecommenders || !!hasEndorsementQuotes;

	return {
		data: { showEndorsements },
	};
}
